/**
 * A watering can, in the two styles the app draws icons in.
 *
 * Watering was drawn as a raindrop, which on a week grid read as "rain
 * that day" rather than "you water that day". Neither the icon set (Lucide)
 * nor the outlook's icon packs has a watering can, and there is no emoji
 * for one, so it is drawn here on the same 24 grid.
 *
 * WateringCan is the outline, a Lucide icon like every other verdict icon
 * (chips, headlines, the Plants page's weather block).
 *
 * Used by: the plant card's verdicts (Verdict) and the week's water line
 * (plant-list weekLineLook: the Plants page's bar, the filter sheet, the
 * Weather page's garden week).
 *
 * @module WateringCan
 */

import { createLucideIcon } from 'lucide-react';

/** The outline: body, handle, spout, rose, and two drops falling from it. */
export const WateringCan = createLucideIcon('WateringCan', [
  ['path', { d: 'M3.5 10h10l-1.1 9.2a1.2 1.2 0 0 1-1.2 1H5.8a1.2 1.2 0 0 1-1.2-1z', key: 'body' }],
  ['path', { d: 'M6 10V8.3a2.5 2.5 0 0 1 5 0V10', key: 'handle' }],
  ['path', { d: 'm13 13.5 5.5-5.5', key: 'spout' }],
  ['path', { d: 'm17 6.5 3 3', key: 'rose' }],
  ['path', { d: 'M21.5 12.5h.01', key: 'drop1' }],
  ['path', { d: 'M19.5 14.5h.01', key: 'drop2' }],
]);

